// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","avatar":"Header_avatar__3tspW"};